import travelRequests from "./travelRequests.component";
import travelRequestsUrls from "./travelRequests.urls";
import TravelRequestsTransforms from "./travelRequests.transforms";

const travelRequestsModule = angular
  .module("app.components.travelRequests", [])
  .component("travelRequestsPage", travelRequests)
  .service("TravelRequestsTransforms", TravelRequestsTransforms)
  .config(travelRequestsUrls);

export default travelRequestsModule;



// WEBPACK FOOTER //
// ./src/pages/travelRequests/travelRequests.module.js